import * as types from '../../constants/action_types'

export const initialState = {
  fetch: {
    isLoading: false,
    completed: false
  },

  save: {
    isLoading: false,
    completed: false
  },

  data: {
    hour: 0,
    day: 0,
    marketplaces: []
  }
}

function emailSettings(state = initialState, action) {
  switch (action.type) {
    case types.PENDING_EMAIL_SETTINGS_ACTION: {
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: true
        }
      }
    }
    case types.COMPLETED_EMAIL_SETTINGS_ACTION: {
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: true
        }
      }
    }
    case types.RESET_EMAIL_SETTINGS_ACTION: {
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: false
        }
      }
    }
    case types.SET_EMAIL_SETTINGS_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        }
      }
    }
    default:
      return state
  }
}

export default emailSettings
